module.exports = __webpack_public_path__ + "img/H03085-01.8919678f.jpg";